import { type Scope, createContextScope } from '@radix-ui/react-context'
import { CardInformativeRootVariants } from './card-informative.styles'
import type { CardInformativeProps } from './card-informative.types'
import { CardInformativeContent } from './components/card-informative-content'
import { CardInformativeDescription } from './components/card-informative-description'
import { CardInformativeIcon } from './components/card-informative-icon'
import { CardInformativeTitle } from './components/card-informative-title'

export const DISPLAY_NAME = 'CardInformative'

type CardInformativeRootProps = CardInformativeProps & {
  children: React.ReactNode
}

export const CardInformativeRoot = (props: CardInformativeRootProps) => {
  const { children, type, variants, iconName, __scopeCardInformative } =
    props as CardInformativeScopedProps<CardInformativeRootProps>

  const cardInformativeProps = {
    type,
    variants,
    iconName,
    scope: __scopeCardInformative,
  } as CardInformativeProps & { scope: Scope }
  return (
    <CardInformativeProvider {...cardInformativeProps}>
      <div
        {...props}
        className={CardInformativeRootVariants({ variants, type })}
      >
        {type !== 'text' && <CardInformativeIcon />}
        {children}
      </div>
    </CardInformativeProvider>
  )
}

CardInformativeRoot.displayName = DISPLAY_NAME

/*
----------------------------------------------------------------
Scope Definition
----------------------------------------------------------------
*/

export type CardInformativeContext = CardInformativeProps & {}

export type CardInformativeScopedProps<P> = P & {
  __scopeCardInformative?: Scope
}

const [createCardInformativeContext] = createContextScope(DISPLAY_NAME)

export const [CardInformativeProvider, useCardInformativeContext]: readonly [
  ProviderType<CardInformativeContext>,
  (consumerName: string, scope: Scope) => CardInformativeContext,
] = createCardInformativeContext<CardInformativeContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const CardInformative = {
  Root: CardInformativeRoot,
  Content: CardInformativeContent,
  Title: CardInformativeTitle,
  Description: CardInformativeDescription,
}
